import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pii-banner',
  templateUrl: './pii-banner.component.html',
  styleUrls: ['./pii-banner.component.css']
})
export class PiiBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
